$(document).ready(function () {
  //Swatch clicked
  $('.swatch-element').on('click touchstart', function(e) {
    $(this).closest('.swatch').find('.swatch-element').removeClass('selected');
    $(this).addClass('selected'); 

    //Add option Color
    if ($(this).hasClass('color')) {
      $(this).closest('.swatch').find('.option_title .jp-tooltip').remove();
      $(this).closest('.swatch').find('.option_title').append($(this).find('.tooltip').clone().removeClass('tooltip').addClass('jp-tooltip'));
    }
  });
  
  //Swatch Mouse Enter
  $('.swatch-element').on('mouseenter', function(e) {

    //Add option Color
    if ($(this).hasClass('color')) {
      $(this).closest('.swatch').find('.option_title .jp-tooltip').remove();
      $(this).closest('.swatch').find('.option_title').append($(this).find('.tooltip').clone().removeClass('tooltip').addClass('jp-tooltip'));
    }
  });
  
  //Swatch Mouse leave
  $('.swatch-element').on('mouseleave', function(e) {

    //Add option Color
    if ($(this).hasClass('color')) {
      $(this).closest('.swatch').find('.option_title .jp-tooltip').remove();
      $(this).closest('.swatch').find('.option_title').append($(this).closest('.swatch').find('.swatch-element.selected .tooltip').clone().removeClass('tooltip').addClass('jp-tooltip'));
    }
  });

  //New Mobile Product Page Expand Animation
  $('body.product-new-mobile .product_page_tabs .faqAccordion button').on('click', function(e) {
    if($(e.target).attr('aria-expanded') == 'true') {
      $(this).next('.jp-close-expand').addClass('expand');
    } else {
      $(this).next('.jp-close-expand').removeClass('expand');
    }
  });

  $('body.product-new-mobile .product_page_tabs .faqAccordion .jp-close-expand').on('click', function(e) {
    $(this).prev('button').trigger('click');
  });

  //Active zoom on product image click
  $(window).resize(function(){
    if ( $(window).width() > 768 ) {
      $('.activeZoom').zoom({
        on: 'click',
        duration: 200,
        magnify: 1.5,
        onZoomIn: function() {
          $(this).addClass('active');
        },
        onZoomOut: function() {
          $(this).removeClass('active');
        }
      }); 
    } else {
      $('.activeZoom').trigger('zoom.destroy') ;
    }
  });
  if ( $(window).width() > 768 ) {
    $('.activeZoom').zoom({
      on: 'click',
      duration: 200,
      magnify: 1.5,
      onZoomIn: function() {
        $(this).addClass('active');
      },
      onZoomOut: function() {
        $(this).removeClass('active');
      }
    }); 
  } else {
    $('.activeZoom').trigger('zoom.destroy') ;
  }

  //Product page thumbnail images  
  if($('.product_gallery_nav .gallery-cell').length >= 11){
    if ($(window).width() < 798) {
      var shown = 8;
      var buttonLabel = 4
      }
    else { 
      var shown = 9;
      var buttonLabel = 5    
      }
    $('.product_gallery_nav .gallery-cell:lt(' + shown + ')').show();
    $('.gallery-cell-less').hide();
    var items =  $('.product_gallery_nav .gallery-cell').length;
    var remainingItems = items - shown;
    $('.product_gallery_nav .image_number').text(remainingItems);
    $('.gallery-cell-more').click(function () {
      $('.product_gallery_nav .gallery-cell:lt('+items+')').show(100);
      $('.gallery-cell-more').hide();
      $('.gallery-cell-less').show();
    });
    $('.gallery-cell-less').click(function () {
      $('.product_gallery_nav .gallery-cell').not(':lt(' + shown + ')').hide(100);
      $('.gallery-cell-more').show();
      $('.gallery-cell-less').hide();
    });
  }
  else { 
    $('.product-details .product_gallery_nav .gallery-cell').show(); 
    $('.gallery-cell-less, .gallery-cell-more').hide();
  }
  //Collection page sticky header  
  var navToggle =  $('.section_select').clone();
  $('.collection_sticky').append(navToggle);
  //$('.sidebar_toggle').on('click', function(){    
  //$('#filterControl').click();
  //$('.hide-sidebar-toggle').toggle();

});


$(document).ready(function () {  
  // Populate the tag bar on load.
  function updateTagsLoad(){ 
    var cloneTagLoad = $('.sidebar input:checked').parent('label').find('.filter_label').clone();
    $('.selected-tags-container').prepend(cloneTagLoad);
    if(!$('.selected-tags-container .filter_label').length){ 
      $('.selected-tags-container').addClass('empty');
    }
    if($('.selected-tags-container .filter_label').length){ 
      $('.view_all_tag').show();
    }    
  };
  updateTagsLoad();

  function updateTags(cloneTag){ 
    console.log('Update tags');
    $('.selected-tags-container').removeClass('empty');
    //Collection page top bar tags
    $('.selected-tags-container').prepend(cloneTag); 
  }; 

  $( ".sidebar" ).on( "change", "input", function( event ) { 
    var dataValue = $(this).data('value');    
    if ($(this).is(':checked')){
      var cloneTag = $(this).parent('label').find('.filter_label').clone();
      updateTags(cloneTag);
    }
    else { 
      $('.selected-tags-container').find(".filter_label[data-value='" + dataValue +"']").hide();
    }
    if($('.selected-tags-container .filter_label:visible').length){ 
      $('.view_all_tag').show();
    }
    else{ 
      $('.view_all_tag').hide();
    }
  });

  $( ".selected-tags-container" ).on( "click", ".filter_label", function( event ) {  
    var cloneValue = $(this).data('value');
    $('.sidebar').find('input[id=' + cloneValue + ']').prop( "checked", false ).change();
    $(this).hide();
  });

  //Link the page filter and the sticky filter  
  $('.collection_sticky .filter-sort').val($('.page-container .filter-sort').val());  
  $('.filter-sort').change(function(){ // when one changes 
    $('.filter-sort').val( $(this).val() ) // they all change 
  })

  /*  --------------------------------------------------------
    [show/hide filter]

    files:    header.liquid, sidebar.liquid, app.js
    notes:    sidebarToggle.classList.add('is-hidden') is
              controlled from app.js (collectionSidebarFilter)
    updated:  04/09/2018 [synced buttons, pp]
    --------------------------------------------------------  */

  var sidebarToggle = document.getElementById('filterControl');
  var sidebar = document.querySelector('.sidebar');
  var topToggle = document.getElementById('h-filterControl');
  var toggleContent = document.getElementsByClassName('hide-sidebar-toggle');
  var mobileBottomFilter = document.querySelector('.hide_filter_mobile');
  var products = document.querySelector('.collection-container');

  var showText = 'Show Filters <i class="icon-down-arrow show-filters"></i>';
  var hideText = 'Hide Filters <i class="icon-up-arrow"></i>';

  if (sidebarToggle) {
    sidebarToggle.onclick = function() {

      if(sidebarToggle.classList.contains('is-hidden') == false){
        for (var i = 0; i < toggleContent.length; i++) {
          toggleContent[i].innerHTML = showText;
        }
        mobileBottomFilter.classList.add("is-hidden");
      }
      else {
        for (var i = 0; i < toggleContent.length; i++) {
          toggleContent[i].innerHTML = hideText;
        }
        mobileBottomFilter.classList.toggle("is-hidden");
      }

      sidebarToggle.classList.toggle('is-hidden');
      products.classList.toggle("expanded");

    };
  }

  if (topToggle) {
    topToggle.onclick = function() {

      if(sidebarToggle.classList.contains('is-hidden') == false){
        for (var i = 0; i < toggleContent.length; i++) {
          var topContent = toggleContent[i].innerHTML;
          if(topContent == showText){
            toggleContent[i].innerHTML = hideText;
          }
          else{
            toggleContent[i].innerHTML = showText;
          }
        }
      }
      else {
        for (var i = 0; i < toggleContent.length; i++) {
          var topContent = toggleContent[i].innerHTML;
          if(topContent == showText){
            toggleContent[i].innerHTML = hideText;
          }
          else{
            toggleContent[i].innerHTML = showText;
          }
        }
      }

      sidebarToggle.classList.toggle('is-hidden');
      sidebar.classList.toggle('is-hidden');
      products.classList.toggle("expanded");

    };
  }

  $('body').on('click', '.hide_filter_mobile, #copyfilter, #h-filterControl_sticky_clone', function(){
    $('#filterControl').click();
    console.log('filter toggle')
  })

  if (window.innerWidth < 768) {
    $('#filterControl').click();
  }


  $('.Form-group input').blur(function(){
    var tmpval = $(this).val();
    if(tmpval == '') {
      $(this).parent('.Form-group').find('label').removeClass('is-filled');
    } else {
      $(this).parent('.Form-group').find('label').addClass('is-filled');
    }
  });

  $('body').on('keyup input', 'textarea', function(){
    if($(this).val().length){ 
      $(this).parent('.Form-group').find('label').addClass('is-filled');
    }
    else { 
      $(this).parent('.Form-group').find('label').removeClass('is-filled');    
    }
  });

  var enableInfiniteScroll = function(){
    if ($('.collection-matrix').length) {
      var infiniteScroll = new Waypoint.Infinite({
        element: $('.collection-matrix')[0],
        items: '.collection-matrix',
        more: '.load-more__btn',
        loadingClass: 'loading-in-progress',
        onBeforePageLoad: function(){
          $('.js-load-more').hide();
        }
      })
      }
  }  



  if($('.scroll-template').length) {
    enableInfiniteScroll();
  }
});




//Edits the Yotpo review stars below product title
$(window).on('load', function() {
  if($('.text-m.write-review-btn-hidden').length === 0){
    var $text;
    var $data = $('.yotpo-small .text-m').text();
    var $arr = $data.split(' ');
    if($arr[0] == 1){
      $text = 'REVIEW' 
    }
    else{ 
      $text = 'REVIEWS'    
    }
    console.log("(" + $arr[0] + ")");
    $('.yotpo-small .text-m').text("(" + $arr[0] + ")" + " " + $text)
  }
});

//New Address JavaScript - Hide and Show sidebar
$('.new-address > #action').click(function(){
  $( ".account-main" ).addClass( "add-address" );
  $( ".return-to-account" ).css('display','block');
  $( "#action" ).css('display','none');
  $( ".addresses > .contact_subheading" ).text("Add New Address")
});

$('.cancel-address-js').click(function(){
  $( ".account-main" ).removeClass( "add-address" );
  $( ".return-to-account" ).css('display','none');
  $( "#action" ).css('display','block');
  $( ".addresses > .contact_subheading" ).text("Your Addresses")
});


/*  --------------------------------------------------------
    [animate form label Yopto]

    files:    -
    notes:    cannot be done with css due to the order of
              the elements.
    issues:   seems to work for first element only
    updated:  06/09/2018 [initial, pp]
    --------------------------------------------------------  */
$(window).on('load', function() {

  var focus = document.querySelector('.y-input');
  if (!focus) return;
  var label = focus.previousElementSibling;

  focus.onfocus = function() {
    label.setAttribute("style","-webkit-transform: scale(0.7) translateY(-18px); transform: scale(0.7) translateY(-18px);");
  };
  focus.onblur = function() {
    if(focus.value == ''){
      label.setAttribute("style","-webkit-transform: scale(1) translateY(0); transform: scale(1) translateY(0);");
    }
  };

});

$(document).ready(function() {
  $(window).scroll(function() {
    if ($(document).scrollTop() >= 590) {
      $('.collection-top').addClass('sticky_visible');
    }
    else {
      $('.collection-top').removeClass('sticky_visible');
    }
  });
});
